import timeFormater from "time-formater";

/**
 * 时间格式化
 * @param {*} v
 */
export function timeFormatDate(v) {
  return timeFormater(Number(v) * 1000).format("YYYY-MM-DD");
}

/**
 *
 * @param {*} v
 */
export function timeFormatYear(v) {
  return timeFormater(Number(v) * 1000).format("YYYY");
}

/**
 *
 * @param {*} v
 */
export function timeFormatMD(v) {
  return timeFormater(Number(v) * 1000).format("MM-DD");
}

/**
 *
 * @param {*} v
 */
export function timeFormat(v) {
  return timeFormater(Number(v) * 1000).format("YYYY-MM-DD HH:mm:ss");
}

/**
 *
 * @param {*} v
 */
export function timeFormatDelYearSecond(v) {
  return timeFormater(Number(v) * 1000).format("MM-DD HH:mm");
}

/**
 *
 * @param {*} v
 */
export function timeFormatDelSecond(v) {
  return timeFormater(Number(v) * 1000).format("YYYY-MM-DD HH:mm");
}

/**
 *
 * @param {*} v
 */
export function timeFormatTime(v) {
  return timeFormater(Number(v) * 1000).format("HH:mm:ss");
}

/**
 *
 * @param {*} v
 */
export function timestamp(v) {
  return timeFormater(v).format("X");
}

/**
 *
 * @param {*} v
 */
export function toNonExponential(v) {
  var m = v.toExponential().match(/\d(?:\.(\d*))?e([+-]\d+)/);
  return v.toFixed(Math.max(0, (m[1] || "").length - m[2]));
}

/**
 *
 * @param {*} func
 * @param {*} wait
 */
export const throttle = (func, wait) => {
  var previous = 0;
  return function() {
    const now = Date.now();
    const context = this;
    const args = arguments;
    if (now - previous > wait) {
      func.apply(context, args);
      previous = now;
    }
  };
};
